import React from 'react';
import { IArticlesItem } from 'constants/types';
import get from 'lodash.get';
import placeholder from 'media/images/placeholder.jpg';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import RoutePath from 'routes/constants/routes';
import { ReactComponent as XIconSVG } from 'media/icons/x.svg';
import useFetchToggle from 'hooks/useFetchToggle';
import { APILinks } from 'constants/api';
import useTranslate from 'hooks/useTranslate';
import { textTrim } from 'utils/text';
import {
  ArticlesCardBasicArticleName,
  ArticlesCardBasicPublishedDate,
  ArticlesCardBasicTitle,
  ArticlesCardControlDelete,
  ArticlesCardCoverHeadMain,
  ArticlesCardCoverMain,
  ArticlesCardDeletedCover,
  ArticlesCardImgMain,
  ArticlesCardImgMainSlider,
  ArticlesCardImgMainWrap,
  ArticlesCardMainWrap,
} from './ArticlesCardStyles';

// Interfaces
export enum ArticlesType {
  CARD_MAIN = 'CARD_MAIN',
  CARD_MAIN_WITH_CONTROL_BOOKMARKS = 'CARD_MAIN_WITH_CONTROL_BOOKMARKS',
}
interface IArticlesCard {
  item: IArticlesItem
  type?: ArticlesType
  isSlider?: boolean
  className?: string
}

// Component
const ArticlesCard = (props: IArticlesCard) => {
  const {
    item,
    type,
    className,
    isSlider = false,
  } = props;

  const history = useHistory();

  const [getText] = useTranslate();

  const journalNameString = get(item, ['journalName']);
  const journalName = textTrim(journalNameString, 20);
  const smallImage = get(item, ['smallImage'], placeholder);
  const publishedAt = get(item, ['publishedAt'], '');
  const id = get(item, ['id']);
  const categoryId = get(item, ['categoryId'], 0);
  const journalId = get(item, ['journalId']);
  const issueId = get(item, ['issueId']);
  const titleString = get(item, ['title']);
  const title = textTrim(titleString, 65);

  const date = moment(publishedAt).format('DD.MM.YYYY');

  const isCardMainWithControlBookmarks = type === ArticlesType.CARD_MAIN_WITH_CONTROL_BOOKMARKS;
  const isCardMain = type === ArticlesType.CARD_MAIN || isCardMainWithControlBookmarks;

  const hasControlBookmarks = isCardMainWithControlBookmarks;
  const hasControl = hasControlBookmarks;

  const apiLink = hasControlBookmarks ? APILinks.BOOKMARKS_ARTICLES_TOGGLE : '';

  const {
    isHas,
    isLoading: isHasLoading,
    handleToggle: handleToggleDeleteHas,
  } = useFetchToggle({
    apiLink,
    initialValue: true,
    initialLoading: false,
    id,
  });

  const isDeleted = !isHas;

  const ArticlesCardWrap = ArticlesCardMainWrap;

  const img = isCardMain && isSlider
    ? (
      <ArticlesCardImgMainSlider
        onError={(e: any) => {
          e.target.onerror = null;
          e.target.src = placeholder;
        }}
        src={smallImage}
        alt={journalName}
        decoding="async"
      />
    )
    : (
      <ArticlesCardImgMainWrap>
        <ArticlesCardImgMain
          onError={(e: any) => {
            e.target.onerror = null;
            e.target.src = placeholder;
          }}
          src={smallImage}
          alt={journalName}
          decoding="async"
        />
      </ArticlesCardImgMainWrap>
    );

  const ArticlesCardCover = ArticlesCardCoverMain;

  const ArticlesCardCoverHead = ArticlesCardCoverHeadMain;

  const ArticlesCardPublishedDate = ArticlesCardBasicPublishedDate;

  const ArticlesCardArticleName = ArticlesCardBasicArticleName;

  const ArticlesCardTitle = ArticlesCardBasicTitle;

  const handleRedirect = () => history.push(
    `${RoutePath.ARTICLES_PATH}/${categoryId}/detail/${journalId}/issues/${issueId}/articles/${id}`,
  );

  const handleToggleDelete = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    handleToggleDeleteHas();
  };

  return (
    <ArticlesCardWrap
      onClick={handleRedirect}
      disabled={isHasLoading}
      className={className}
    >
      {img}
      <ArticlesCardCover>
        <ArticlesCardCoverHead>
          <ArticlesCardPublishedDate>{date}</ArticlesCardPublishedDate>
          <ArticlesCardArticleName>{journalName}</ArticlesCardArticleName>
        </ArticlesCardCoverHead>
        <ArticlesCardTitle>{title}</ArticlesCardTitle>
      </ArticlesCardCover>
      {hasControl ? (
        <ArticlesCardControlDelete
          disabled={isHasLoading}
          onClick={handleToggleDelete}
        >
          <span><XIconSVG /></span>
        </ArticlesCardControlDelete>
      ) : null}
      {isDeleted && !isHasLoading ? (
        <ArticlesCardDeletedCover
          onClick={handleToggleDelete}
        >
          {getText(['words', 'hasDeletedWithUndo'])}
        </ArticlesCardDeletedCover>
      ) : null}
    </ArticlesCardWrap>
  );
};

ArticlesCard.defaultProps = {
  className: '',
  type: ArticlesType.CARD_MAIN,
  isSlider: false,
};

export default ArticlesCard;
